export const UI_LANGUAGE_TRANSLATION_KEYS = {
  en: { key: "languageOptionEnKey", value: "English" },
  sq: { key: "languageOptionSqKey", value: "Albanian" },
  ar: { key: "languageOptionArKey", value: "Arabic" },
  az: { key: "languageOptionAzKey", value: "Azerbaijani" },
  bn: { key: "languageOptionBnKey", value: "Bengali" },
  bg: { key: "languageOptionBgKey", value: "Bulgarian" },
  ca: { key: "languageOptionCaKey", value: "Catalan" },
  zh: { key: "languageOptionZhKey", value: "Chinese" },
  cs: { key: "languageOptionCsKey", value: "Czech" },
  da: { key: "languageOptionDaKey", value: "Danish" },
  nl: { key: "languageOptionNlKey", value: "Dutch" },
  eo: { key: "languageOptionEoKey", value: "Esperanto" },
  et: { key: "languageOptionEtKey", value: "Estonian" },
  fi: { key: "languageOptionFiKey", value: "Finnish" },
  fr: { key: "languageOptionFrKey", value: "French" },
  de: { key: "languageOptionDeKey", value: "German" },
  el: { key: "languageOptionElKey", value: "Greek" },
  iw: { key: "languageOptionIwKey", value: "Hebrew" },
  hi: { key: "languageOptionHiKey", value: "Hindi" },
  hu: { key: "languageOptionHuKey", value: "Hungarian" },
  ga: { key: "languageOptionGaKey", value: "Irish" },
  it: { key: "languageOptionItKey", value: "Italian" },
  ja: { key: "languageOptionJaKey", value: "Japanese" },
  ko: { key: "languageOptionKoKey", value: "Korean" },
  lv: { key: "languageOptionLvKey", value: "Latvian" },
  lt: { key: "languageOptionLtKey", value: "Lithuanian" },
  ms: { key: "languageOptionMsKey", value: "Malay" },
  no: { key: "languageOptionNoKey", value: "Norwegian" },
  fa: { key: "languageOptionFaKey", value: "Persian" },
  pl: { key: "languageOptionPlKey", value: "Polish" },
  pt: { key: "languageOptionPtKey", value: "Portuguese" },
  ro: { key: "languageOptionRoKey", value: "Romanian" },
  ru: { key: "languageOptionRuKey", value: "Russian" },
  sk: { key: "languageOptionSkKey", value: "Slovak" },
  sl: { key: "languageOptionSlKey", value: "Slovenian" },
  es: { key: "languageOptionEsKey", value: "Spanish" },
  sv: { key: "languageOptionSvKey", value: "Swedish" },
  tl: { key: "languageOptionTlKey", value: "Filipino" },
  th: { key: "languageOptionThKey", value: "Thai" },
  tr: { key: "languageOptionTrKey", value: "Turkish" },
  uk: { key: "languageOptionUkKey", value: "Ukrainian" },
  ur: { key: "languageOptionUrKey", value: "Urdu" },
} as const
